import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["pdf", "getIframeSrc", "fileName", "showFileName", "width", "height", "style", "additionalButtons", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DownloadOutlined } from '@ant-design/icons';
import { BlobProvider, PDFViewer } from '@react-pdf/renderer';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuDeviceTarget from "../DixuDeviceTarget/DixuDeviceTarget";
import DixuErrorBoundary from "../DixuErrorBoundary/DixuErrorBoundary";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuSpin from "../DixuSpin/DixuSpin";
import { useTranslation } from "../../i18n";
import React, { useEffect, useState } from 'react';
import { toRem } from "../../utils/Utils";
const DixuPDFViewer = _ref => {
  let {
      pdf,
      getIframeSrc,
      fileName,
      showFileName,
      width,
      height,
      style,
      additionalButtons,
      className,
      children: _children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-pdf-viewer', 'border-radius-xs', 'box-shadow-1', className);
  const linkClasses = classNames('dixu-pdf-viewer__link');
  const {
    0: iframeSrc,
    1: setIframeSrc
  } = useState();
  const {
    t
  } = useTranslation(['common']);
  useEffect(() => {
    if (getIframeSrc) {
      (async () => {
        setIframeSrc(window.URL.createObjectURL(await getIframeSrc()));
      })();
    }
  }, []);
  if (!pdf && !getIframeSrc || !process.browser) {
    return null;
  }
  const commonViewerProps = _objectSpread({
    style: _objectSpread({
      minHeight: toRem(height) || '60vh'
    }, style),
    width: toRem(width) || '100%',
    height: toRem(height) || '60vh',
    className: classes
  }, rest);
  return /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16],
    justify: "center",
    align: "middle"
  }, /*#__PURE__*/React.createElement(DixuErrorBoundary, null, /*#__PURE__*/React.createElement(DixuDeviceTarget, {
    desktop: true
  }, getIframeSrc && !iframeSrc && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle",
    style: {
      height: commonViewerProps.height
    }
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuSpin, null)))), (pdf || iframeSrc) && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, pdf && /*#__PURE__*/React.createElement(PDFViewer, _objectSpread(_objectSpread({}, commonViewerProps), {}, {
    children: pdf
  })), iframeSrc && /*#__PURE__*/React.createElement("iframe", _objectSpread(_objectSpread({}, commonViewerProps), {}, {
    title: fileName,
    src: iframeSrc
  })))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton.Group, {
    justify: "center"
  }, pdf && /*#__PURE__*/React.createElement(BlobProvider, {
    document: pdf,
    fileName: fileName
  }, _ref2 => {
    let {
      url,
      loading,
      error
    } = _ref2;
    if (error) {
      return /*#__PURE__*/React.createElement(DixuButton, {
        type: "primary",
        shadow: "1",
        icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
        disabled: true,
        className: linkClasses
      }, t('common:CreatingDocumentFailed'));
    }
    return /*#__PURE__*/React.createElement(DixuButton, {
      type: "primary",
      shadow: "1",
      icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
      href: url,
      loading: loading,
      download: fileName,
      external: true,
      className: linkClasses
    }, loading && t('common:CreatingDocument'), !loading && /*#__PURE__*/React.createElement(React.Fragment, null, t('common:DownloadDocument'), ' ', showFileName && fileName && /*#__PURE__*/React.createElement(React.Fragment, null, "(", fileName, ")")));
  }), getIframeSrc && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    shadow: "1",
    icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
    href: iframeSrc,
    loading: !iframeSrc,
    download: fileName,
    external: true,
    className: linkClasses
  }, !iframeSrc && t('common:CreatingDocument'), iframeSrc && /*#__PURE__*/React.createElement(React.Fragment, null, t('common:DownloadDocument'), ' ', showFileName && fileName && /*#__PURE__*/React.createElement(React.Fragment, null, "(", fileName, ")")))), additionalButtons))));
};
DixuPDFViewer.defaultProps = {
  fileName: undefined,
  additionalButtons: undefined,
  showFileName: false
};
export default DixuPDFViewer;